import { CallIntelligenceWritebackService } from '@weave/schema-gen-ts/dist/schemas/call-intelligence/writeback/v1/writeback_service.pb';
import { bindHTTP } from '@frontend/schema';

export const SchemaCallIntelligenceWritebackV1Service = bindHTTP(CallIntelligenceWritebackService);
export const serviceName = 'call-intelligence-writeback-v1' as const;
